__turbopack_context__.v({
  "footer": "zWWWLG_footer",
});
